import React from 'react';
import { TrendingUp, Users, Target, Award } from 'lucide-react';

const ApexStats = () => {
  const stats = [
    {
      id: 'stat-consultations',
      icon: Users,
      value: '7,500+',
      label: 'Consultations Delivered',
      description: 'In the small group PT & boutique gym space'
    },
    {
      id: 'stat-increase',
      icon: TrendingUp,
      value: '28%',
      label: 'Average Sales Increase',
      description: 'Without increasing leads or ad spend'
    },
    {
      id: 'stat-focus',
      icon: Target,
      value: '100%',
      label: 'Fitness Focused',
      description: 'We only work with gyms — nothing else'
    },
    {
      id: 'stat-exclusive',
      icon: Award,
      value: '1 Per Area',
      label: 'Local Exclusivity',
      description: 'We never work with your competitors'
    }
  ];

  return (
    <section className="relative py-20 md:py-28 bg-[#0d0d0d]">
      {/* Top border accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-px bg-gradient-to-r from-transparent via-[#22C55E]/50 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="text-[#22C55E] text-sm font-medium tracking-[0.2em] uppercase">
            Why Gym Owners Trust Us
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-4">
            Real Results, Not Empty Promises
          </h2>
        </div>

        {/* Stats grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.id}
              data-testid={stat.id}
              className="group relative bg-[#121212] border border-[#27272A] rounded-2xl p-8 hover:border-[#22C55E]/50 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#22C55E]/10 flex items-center justify-center mb-6 group-hover:bg-[#22C55E]/20 transition-colors">
                <stat.icon className="w-7 h-7 text-[#22C55E]" />
              </div>

              {/* Value */}
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                {stat.value}
              </div>

              {/* Label */}
              <h3 className="text-lg font-semibold text-white mb-2">
                {stat.label}
              </h3>

              {/* Description */}
              <p className="text-sm text-[#71717A]">
                {stat.description}
              </p>

              {/* Hover glow effect */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#22C55E]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApexStats;
